import $ from "jquery";

class Tabs {
	constructor(passedElement) {
		let self = this;

		self.elem = passedElement;
	}

	init() {
		let self = this;

		$(document).ready(function() {
			self.triggers = self.elem.querySelectorAll('.js-tab-trigger');
			self.panels = self.elem.querySelectorAll('.js-tab-panel');

			setTimeout(() => {
				// data tables and flickity need to be displayed when first intitalized
				// So show all panels then after 1s hide them all except first.
				self.displaySelectedPanel(self.triggers[0].getAttribute('aria-controls'));
			}, 1000);

			self.triggers.forEach(trigger => {
				trigger.addEventListener('click', evt => {
					evt.preventDefault();

					self.deselectAllTriggers();
					trigger.classList.add('active');
					trigger.setAttribute('aria-selected', true);

					self.displaySelectedPanel(trigger.getAttribute('aria-controls'));

					// manually trigger window resize event incase tab contains a datatable and the window
					// has resized since it was first initialized.
					$(window).trigger('resize');
				});
			});
		});
	}

	deselectAllTriggers() {
		let self = this;

		self.triggers.forEach(trigger => {
			trigger.classList.remove('active');
			trigger.setAttribute('aria-selected', false);
		});
	}

	displaySelectedPanel(id) {
		let self = this;

		self.panels.forEach(panel => {
			if(panel.id === id) {
				panel.style.display = "block";
			} else {
				panel.style.display = "none";
			}		
		});
	}
}

export default Tabs;